// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"Hz-z","smallCardRow":"Iz-z","largeCardRow":"Jz-z","productSearchRow":"Kz-z","curatedRow":"Lz-z"};